import { useMediaQuery } from "react-responsive";

export const ULTRAWIDE_BREAKPOINT = 1800;
export const DESKTOP_BREAKPOINT = 1024;
export const TABLET_BREAKPOINT = 768;
export const MOBILE_BREAKPOINT = 0;

// Module-level settings: useMediaQuery re-runs an effect whenever the settings object identity changes.
const ultrawideUp = { query: `(min-width: ${ULTRAWIDE_BREAKPOINT}px)` };
const desktopUp = { query: `(min-width: ${DESKTOP_BREAKPOINT}px)` };
const desktopDown = { query: `(max-width: ${DESKTOP_BREAKPOINT}px)` };
const tabletUp = { query: `(min-width: ${TABLET_BREAKPOINT}px)` };
const tabletDown = { query: `(max-width: ${TABLET_BREAKPOINT}px)` };
const mobileUp = { query: `(min-width: ${MOBILE_BREAKPOINT}px)` };
const mobileDown = { query: `(max-width: ${TABLET_BREAKPOINT - 1}px)` };

export const useBreakpoints = () => {
	const isUltrawideUp = useMediaQuery(ultrawideUp);
	const isDesktopUp = useMediaQuery(desktopUp);
	const isDesktopDown = useMediaQuery(desktopDown);
	const isTabletUp = useMediaQuery(tabletUp);
	const isTabletDown = useMediaQuery(tabletDown);
	const isMobileUp = useMediaQuery(mobileUp);
	const isMobileDown = useMediaQuery(mobileDown);

	return {
		isUltrawideUp,
		isDesktopUp,
		isDesktopDown,
		isTabletUp,
		isTabletDown,
		isMobileUp,
		isMobileDown,
	};
};
